import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../constants";

const NjcReport4Table = ({ cases, search, count }) => {
  // Check if this is an individual judge report
  const isIndividualReport = search.reportType === "NJC/MCPJ/4_INDV";

  return (
    <div
      style={{
        marginBottom: "20px",
      }}
      className="table"
    >
      <div className="section-cases-report">
        <span>List of all contested cases and judgments</span>
        <div className="no-print">
          <span className="specialaction">
            <Link
              to={`/reports/print/njc4/${search.eventtype}/${search.judgeid}/${search.divisionid}/${search.lastdate}`}
              target="_blank"
            >
              Print
            </Link>
          </span>
        </div>
      </div>
      <table className="case-table">
        <thead>
          <tr>
            <th className="col-id">S/N</th>
            <th className="col-title">
              A<br />
              Case Type
            </th>
            <th className="col-title">
              B<br />
              {isIndividualReport ? "Suit Number" : "Case Number"}
            </th>
            <th className="col-medium">
              C<br />
              Date Filed
            </th>
            <th className="col-title">
              D<br />
              {isIndividualReport
                ? "Date of hearing commencement"
                : "Assigned Date"}
            </th>
            <th className="col-title">
              E<br />
              {isIndividualReport
                ? "Judgement Date"
                : "Date of hearing commencement"}
            </th>
            <th className="col-medium">
              F<br />
              {isIndividualReport ? "Duration" : "Judgement Date"}
            </th>
            {isIndividualReport && (
              <th className="col-medium">
                G<br />
                Number of witness
              </th>
            )}
            {!isIndividualReport && (
              <>
                <th className="col-medium">
                  H<br />
                  Duration
                </th>
                <th className="col-medium">
                  I<br />
                  Number of witness
                </th>
              </>
            )}
            <th className="col-title">Remarks</th>
          </tr>
        </thead>
        <tbody>
          {cases?.map((opt, index) => (
            <tr key={index}>
              <td>{opt.id}</td>
              <td>{opt.caseType ?? "N/A"}</td>
              <td>{opt.caseNumber ?? "N/A"}</td>
              <td>{opt.createdOn ? formatDate(opt.createdOn) : "N/A"}</td>
              {isIndividualReport ? (
                <>
                  <td>
                    {opt.firstHearirng ? formatDate(opt.firstHearirng) : "N/A"}
                  </td>
                  <td>
                    {opt.judgementDate ? formatDate(opt.judgementDate) : "N/A"}
                  </td>
                  <td>{opt.agebyDay ?? "0"}</td>
                  <td>{opt.witness}</td>
                </>
              ) : (
                <>
                  <td>{opt.assignedOn ? formatDate(opt.assignedOn) : "N/A"}</td>
                  <td>
                    {opt.firstHearirng ? formatDate(opt.firstHearirng) : "N/A"}
                  </td>
                  <td>
                    {opt.judgementDate ? formatDate(opt.judgementDate) : "N/A"}
                  </td>
                  <td>{opt.agebyDay ?? "0"}</td>
                  <td>{opt.witness ?? "0"}</td>
                </>
              )}
              <td>{opt.remark ?? "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NjcReport4Table;
